module.exports = __webpack_public_path__ + "static/img/luxuanhua.1322f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/luxuanhua.png
// module id = 6DZW
// module chunks = 1